/**
 * NAZ AI - ChecklistEngine v1.0
 * Specialized Intent Mapping for Sudanese Automotive Technicians
 */

export interface VoiceCommand {
    intent: 'COMPLETE' | 'SKIP' | 'REPEAT' | 'UNDO' | 'UNKNOWN';
    originalText: string;
}

const SUDANESE_TRIGGERS = {
    COMPLETE: ["تمام", "شفتها", "خلاص", "انجزتها", "تمت", "عملتها", "ركبت", "غيرتها", "فحصتها"],
    SKIP: ["فوتها", "بعدين", "البعدو", "تاني شنو", "اللي بعدو", "ما هسي", "خليها"],
    REPEAT: ["عيد لي", "ما سمعتك", "قلت شنو", "كرر", "تاني مرة"],
    UNDO: ["غلط", "ارجع", "لسه", "ما خلصتها", "احذف", "تراجع"]
};

export class ChecklistEngine {
    /**
     * Processes a Sudanese Arabic transcript and maps it to a checklist command.
     */
    public static parseTranscript(transcript: string): VoiceCommand {
        const text = transcript.trim().toLowerCase();

        if (this.matches(text, SUDANESE_TRIGGERS.COMPLETE)) return { intent: 'COMPLETE', originalText: transcript };
        if (this.matches(text, SUDANESE_TRIGGERS.SKIP)) return { intent: 'SKIP', originalText: transcript };
        if (this.matches(text, SUDANESE_TRIGGERS.REPEAT)) return { intent: 'REPEAT', originalText: transcript };
        if (this.matches(text, SUDANESE_TRIGGERS.UNDO)) return { intent: 'UNDO', originalText: transcript };

        return { intent: 'UNKNOWN', originalText: transcript };
    }

    private static matches(text: string, triggers: string[]): boolean {
        // Check for exact matches or partial context
        return triggers.some(t => text.includes(t));
    }

    /**
     * Generates a realistic Sudanese "Osta" response for the technician.
     */
    public static getFeedback(intent: 'COMPLETE' | 'SKIP' | 'ERROR'): string {
        const feedbacks: Record<'COMPLETE' | 'SKIP' | 'ERROR', string[]> = {
            COMPLETE: ["عاش يا هندسة، تمت بنجاح.", "تسلم يدك، الخطوة دي خلصت.", "تمام التمام، واصل يا بطل."],
            SKIP: ["ما مشكلة، بنرجع ليها بعدين.", "تمام، نشوف العطل التاني.", "فوتناها، ركز في دي."],
            ERROR: ["ما فهمتك يا هندسة، كرر تاني؟", "الصوت ما واضح، عيد الكلام دا."]
        };

        const list = feedbacks[intent];
        return list[Math.floor(Math.random() * list.length)] || "تمام يا هندسة.";
    }
}
